import { render, staticRenderFns } from "./ContactInfoEdit.vue?vue&type=template&id=2fd232a6&scoped=true"
import script from "./ContactInfoEdit.vue?vue&type=script&lang=js"
export * from "./ContactInfoEdit.vue?vue&type=script&lang=js"
import style0 from "./ContactInfoEdit.vue?vue&type=style&index=0&id=2fd232a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd232a6",
  null
  
)

export default component.exports